import * as Yup from "yup";

import { ProductCategory, validProducts } from "../valuablesConstants";

import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { useTexts } from "Components/TextContext";
import { ValuablesProductFormState } from "..";
import { getCoverageAmountSchema } from "../valuablesValidation";

export const getBaseSchema = (
  getText: ReturnType<typeof useTexts>["getText"],
): Yup.ObjectSchema<
  Pick<ValuablesProductFormState, "product" | "description" | "year">
> =>
  Yup.object()
    .defined()
    .shape({
      product: Yup.mixed<ProductCategory>()
        .oneOf(validProducts)
        .required(getText("valuablesform.validation.product-required")),
      description: Yup.string().when("product", {
        is: (value: ProductCategory) =>
          value !== ProductCategory.GOLF_EQUIPEMENT,
        then: (schema) =>
          schema.required(
            getText("valuablesform.validation.description-required"),
          ),
      }),
      year: Yup.string().required(
        getText("valuablesform.validation.production_year-required"),
      ),
    });

export const validationSchema = (
  getText: ReturnType<typeof useTexts>["getText"],
): Yup.ObjectSchema<ValuablesProductFormState> =>
  getBaseSchema(getText)
    .concat(getCoverageAmountSchema(getText))
    .concat(
      getInjuriesSchema(
        "valuablesform.validation.injuries-breaking",
        getText("valuablesform.validation.injuries-required"),
        getText("valuablesform.validation.injury_year-required"),
      ),
    );
